import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import {
  requestCreateSupportTemplate,
  requestViewSupportTemplate,
  requestUpdateSupportTemplate
} from './support-template.actions';
import { requestViewAllProgrammes, requestViewProgramme } from '../programme/programme.actions';
import {
  getCreateSupportTemplateRequest,
  getViewSupportTemplateRequest,
  getUpdateSupportTemplateRequest
} from './support-template.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setSupportTemplate } from '../../slices/programme/support/support.slice';

import { SUCCESS, ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performCreateSupportTemplateRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner('Creating Support Template'));

    const [endpoint, options] = getCreateSupportTemplateRequest(input);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner('Creating Support Template'));
    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
    yield put(requestViewProgramme({ externalReference: input.programmeExternalReference }));
    yield put(requestViewSupportTemplate({ externalReference: input.programmeExternalReference }));
    yield put(requestViewAllProgrammes({}));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Creating Support Template'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForCreateSupportTemplateRequest() {
  yield takeLatest(requestCreateSupportTemplate.type, performCreateSupportTemplateRequest);
}

export function* performViewSupportTemplateRequest({ payload }) {
  const { externalReference, onSuccess } = payload;

  try {
    yield put(addSpinner('Retrieving Support Template'));

    const [endpoint, options] = getViewSupportTemplateRequest(externalReference);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(setSupportTemplate(data.supportTemplates[0]));
    yield put(removeSpinner('Retrieving Support Template'));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Retrieving Support Template'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewSupportTemplateRequest() {
  yield takeLatest(requestViewSupportTemplate.type, performViewSupportTemplateRequest);
}

export function* performUpdateSupportTemplateRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner('Updating Support Template'));

    const [endpoint, options] = getUpdateSupportTemplateRequest(input);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner('Updating Support Template'));
    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
    yield put(requestViewSupportTemplate({ externalReference: input.programmeExternalReference }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Updating Support Template'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForUpdateSupportTemplateRequest() {
  yield takeLatest(requestUpdateSupportTemplate.type, performUpdateSupportTemplateRequest);
}

export default function* supportTemplateSaga() {
  yield all([
    watchForCreateSupportTemplateRequest(),
    watchForViewSupportTemplateRequest(),
    watchForUpdateSupportTemplateRequest()
  ]);
}
